import { render } from "./TheHeader.vue?vue&type=template&id=f8999db0&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=f8999db0&scoped=true&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8999db0"]])

export default __exports__